import styled from 'styled-components';
import appTheme from '../../../themes/Theme';
import { BreakPoints } from '../../../constants/BreakPoints';

export const StyledWrapper = styled.h1`
  color: ${appTheme.textColor};
  font-size: ${(props) => props.fontSize+'px'};

  /* @media (max-width: ${BreakPoints.mobileL}) {
    font-size: 26px;
  } */
`;
